/** Icons of the weather of the map (ADR 0021): one per layer and per source, the same set as the
 *  rest (outline, grid 24, stroke 1.7); `Icon` merges every file. */
const CLOUD = 'M7.2 16.6h9.6a3.8 3.8 0 0 0 .5-7.6 5.4 5.4 0 0 0-10.4 1.4 3.1 3.1 0 0 0 .3 6.2Z';

export const WEATHER_PATHS = {
  // Radar: rain rate.
  rain: (
    <>
      <path d="M7.2 13.4h9.6a3.6 3.6 0 0 0 .5-7.2 5.2 5.2 0 0 0-10 1.3 3 3 0 0 0-.1 5.9Z" />
      <path d="M8.4 16.4l-.9 2.4M12.2 16.4l-.9 2.4M16 16.4l-.9 2.4M10.3 19.6l-.6 1.6M14.1 19.6l-.6 1.6" />
    </>
  ),
  // Cloud tops from the satellite.
  cloud: <path d={CLOUD} />,
  // Storm cells.
  storm: (
    <>
      <path d="M7.2 13.4h9.6a3.6 3.6 0 0 0 .5-7.2 5.2 5.2 0 0 0-10 1.3 3 3 0 0 0-.1 5.9Z" />
      <path d="M12.6 14.6 10.4 18h3.2l-2.2 3.4" />
    </>
  ),
  // Wind layer and forecast wind.
  wind: (
    <path d="M3.4 9h10.4a2.6 2.6 0 1 0-2.6-2.6M3.4 12.6h15a2.6 2.6 0 1 1-2.6 2.6M3.4 16.2h7.4" />
  ),
  // Where the wind blows to, rotated on the map: north up.
  direction: <path d="M12 3.4v17.2M6.6 8.8 12 3.4l5.4 5.4" />,
  // River gauges.
  droplet: (
    <path d="M12 3.2c3.6 4.3 5.8 7.6 5.8 10.4a5.8 5.8 0 0 1-11.6 0c0-2.8 2.2-6.1 5.8-10.4Z" />
  ),
  // Temperature observed.
  thermometer: (
    <>
      <path d="M10 13.8V5.2a2 2 0 0 1 4 0v8.6a3.8 3.8 0 1 1-4 0Z" />
      <path d="M12 10.2v6" />
    </>
  ),
  // Airports near the mission (METAR).
  plane: (
    <path d="M12 3.2c.9 0 1.4.8 1.4 2v4.4l6.8 4v2l-6.8-2v4l2 1.6v1.6L12 19.8l-3.4 1v-1.6l2-1.6v-4l-6.8 2v-2l6.8-4V5.2c0-1.2.5-2 1.4-2Z" />
  ),
  // Space weather: a satellite with its panels.
  satellite: (
    <>
      <rect x="9.6" y="9.6" width="4.8" height="4.8" transform="rotate(45 12 12)" />
      <path d="M4.2 7.4 7.4 4.2l3 3-3.2 3.2zM13.6 16.8l3.2-3.2 3 3-3.2 3.2zM15.8 3.6a4.6 4.6 0 0 1 4.6 4.6" />
    </>
  ),
  play: <path d="M8 5.2v13.6L19 12Z" />,
  pause: <path d="M8.4 5.4v13.2M15.6 5.4v13.2" />,
} as const;
